class PaginationCaseStudies {
  constructor(el) {
    this.el = el;

    this.bindListeners();
  }

  bindListeners() {
    this.el.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick() {
    const isDesktop = window.matchMedia("(min-width: 1200px)").matches;
  
    const selector = isDesktop
      ? ".case-studies__card-wrapper--desktop.hide"
      : ".case-studies__card-wrapper--mobile.hide";
  
    const hiddenItems = document.querySelectorAll(selector);
  
    Array.from(hiddenItems).slice(0, 3).forEach(item => {
      item.classList.add("show");
      item.classList.remove("hide");
    });
  
    const remainingHide = document.querySelectorAll(selector).length > 0;
  
    if (!remainingHide) {
      this.el.classList.add("hide");
    }
  }
  
}

function initPaginationCaseStudies() {
  const showMoreBtns = document.querySelectorAll(".case-studies__pagination");

  showMoreBtns.forEach(btn => {
    new PaginationCaseStudies(btn);
  });
}

initPaginationCaseStudies();